import { GoogleGenAI } from "@google/genai";
import { SYSTEM_PROMPT } from "../constants";


const API_KEY = (process.env.REACT_APP_GEMINI_API_KEY || "").trim();


export const ai = API_KEY ? new GoogleGenAI({ apiKey: API_KEY }) : null;

let chatInstance = null;

export const getChat = () => {
  if (!ai) {
    throw new Error(
      "Missing Gemini API key. Add REACT_APP_GEMINI_API_KEY in frontend/.env and restart npm start."
    );
  }

  if (!chatInstance) {
    chatInstance = ai.chats.create({
      model: "gemini-2.0-flash", 
      config: {
        systemInstruction: SYSTEM_PROMPT,
        temperature: 0.7,
      },
    });
  }
  return chatInstance;
};

export const sendMessageStream = async (message, onChunk) => {
  const chat = getChat();
  const response = await chat.sendMessageStream({ message });

  let fullText = "";
  for await (const chunk of response) {
    const text = chunk.text;
    if (text) {
      fullText += text;
      onChunk(fullText);
    }
  }
  return fullText;
};

export const resetChat = () => {
  chatInstance = null;
};
